import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import styles from "./newDashboardLayout.module.scss";
import { useEffect} from "react";
import { ReactComponent as Logo } from "../../assets/headerLogo.svg";
import { ReactComponent as Menu } from "../../assets/menu.svg";
import { ReactComponent as Dash } from "../../assets/nav-dash.svg";
import CustomDropdown from "../../customs/dropDown/dropdown";
import classNames from "classnames";
import { Button, Drawer } from "antd";
import { useState } from "react";
import { useScreenWidth } from "../../utils/useScreenWidth";
import { ReactComponent as Message } from "../../assets/message.svg";
import { ReactComponent as ProfileLogo } from "../../assets/profile-logo.svg";
import { ReactComponent as Signout } from "../../assets/logout.svg";
import { useAtom } from "jotai";
import { userData } from "../../state";
import { logout } from "../../utils/logout";

interface Links {
  label: string;
  url?: string;
  subLinks?: Links[];
}

const Layout = () => {
  const { width } = useScreenWidth();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [user] = useAtom(userData);
  const navigate = useNavigate();

  // Automatically logout when token expires
     useEffect(() => {
      if (user?.expires_in) {
        const expirationTime = user.expires_in * 1000; // Convert to milliseconds
        const logoutTimer = setTimeout(() => {
          logout(); // Auto logout when token expires
          navigate("/signIn"); // Redirect to the login page
        }, expirationTime);
  
        return () => clearTimeout(logoutTimer); // Cleanup the timer on unmount or user change
      }
    }, [user, navigate]);

  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);


  const links: Links[] = [
    { label: "Dashboard", url: "/dashboard" },
    {
      label: "My Autoloads",
      subLinks: [
        { label: "Loads", url: "/loads" },
        { label: "Customer", url: "/customer" },
        { label: "Driver", url: "/driver" },
        { label: "Truck", url: "/truck" },
        { label: "My Trips", url: "/trips" },
      ],
    },
    { label: "Available loads", url: "/available-loads" },
    { label: "Available terminals", url: "/terminal" },
    { label: "Available warehouse", url: "/warehouse" },
  ];

  return (
    <main className={styles.container}>
      <nav className={styles.header}>
        <div className={styles.navList}>
          <div className={styles.menu}>
            <Button onClick={() => setDrawerOpen(true)} ghost icon={<Menu />} />
          </div>
          <Logo />
          <Drawer
            title="Menu"
            width={width > 912 ? 378 : "60%"}
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            placement="left"
          >
            <ul>
              {links.map((link, index) => {
                if (link.url) {
                  return (
                    <li className={styles.link} key={index}>
                      <NavLink
                        to={link.url}
                        onClick={() => setDrawerOpen(false)}
                        className={({ isActive }) =>
                          isActive
                            ? classNames(styles.link, styles.active)
                            : styles.link
                        }
                      >
                        {link.label}
                      </NavLink>
                    </li>
                  );
                }
                return (
                  <CustomDropdown
                    key={`link-${index}`}
                    dropdownButton={<li className={styles.link}>{link.label}</li>}
                    dropdownContent={link.subLinks?.map((subLink, subIndex) => (
                      <Link
                        to={subLink.url!}
                        className={styles.sublink}
                        key={`${index}-${subIndex}`}
                        onClick={() => setDrawerOpen(false)}
                      >
                        {subLink.label}
                      </Link>
                    ))}
                  />
                );
              })}
            </ul>
          </Drawer>

          <div className={styles.drawerContent}>
            <ul className={styles.links}>
              {links.map((link, index) => {
                const isLastLink = index === links.length - 1;
                if (link.url) {
                  return (
                    <div className={styles.linkWithDash} key={`link-${index}`}>
                      <NavLink
                        to={link.url}
                        className={({ isActive }) =>
                          isActive
                            ? classNames(styles.link, styles.active)
                            : styles.link
                        }
                      >
                        {link.label}
                      </NavLink>
                      {!isLastLink && <Dash className={styles.dashIcon} />}
                    </div>
                  );
                }
                return (
                  <div className={styles.linkWithDash} key={`link-${index}`}>
                    <CustomDropdown
                      dropdownButton={<li className={styles.link}>{link.label}</li>}
                      dropdownContent={link.subLinks?.map((subLink, subIndex) => (
                        <Link
                          to={subLink.url!}
                          className={styles.sublink}
                          key={`${index}-${subIndex}`}
                          onClick={() =>
                            setActiveDropdown(
                              activeDropdown === link.label ? null : link.label
                            )}
  
                        >
                          {subLink.label}
                        </Link>
                      ))}
                    />
                    {!isLastLink && <Dash className={styles.dashIcon} />}
                  </div>
                );
              })}
            </ul>
          </div>

          <div className={styles.spaceHeader}>
            <Message />
            <ProfileLogo  onClick={() => navigate("/view-profile")}/>
            <button 
            className={styles.menuCollapse}
            onClick={logout}>
            <Signout />
            </button>
            

          </div>
        </div>
      </nav>
      <div className={styles.content}>
        <Outlet />
      </div>
    </main>
  );
};

export default Layout;
